import { types } from "../actions";

const initialState = {
  paginationNavSource: null,
  Licenses: {
    searchTerm: "",
    filterOptions: {},
    currentPage: 1,
    activeFilterTab: null
  },
  Alerts: {
    searchTerm: "",
    filterOptions: {},
    currentPage: 1,
    activeFilterTab: null
  },
  DiscoveredCamerasTab: {
    searchTerm: "",
    filterOptions: {},
    currentPage: 1,
    activeFilterTab: null,
    selectedSiteId: null
  },
  UserTable: {
    searchTerm: "",
    filterOptions: {},
    currentPage: 1,
    activeFilterTab: null,
  },
  UserGroups: {
    searchTerm: "",
    filterOptions: {},
    currentPage: 1,
    activeFilterTab: null,
  },
  PendingInvites: {
    searchTerm: "",
    filterOptions: {},
    currentPage: 1,
    activeFilterTab: null,
  },
  Sites: {
    searchTerm: "",
    filterOptions: {},
    currentPage: 1,
    activeFilterTab: null
  },
  CompanionTab: {
    searchTerm: "",
    filterOptions: {},
    currentPage: 1,
    activeFilterTab: null,
  },
  CompanionDevicesTab: {
    searchTerm: "",
    filterOptions: {},
    currentPage: 1,
    activeFilterTab: null,
  },
  CamerasTab: {
    searchTerm: "",
    filterOptions: {},
    currentPage: 1,
    activeFilterTab: null,
  },
  AssociatedCamerasTab: {
    searchTerm: "",
    filterOptions: {},
    currentPage: 1,
    activeFilterTab: null,
  },
};

const tableFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_TABLE_FILTER_STATE: {
      const { pageIdentifier, propName, value } = action.payload;

      if (!pageIdentifier) {
        console.warn("Missing pageIdentifier in UPDATE_TABLE_FILTER_STATE action");
        return state;
      }

      if (!state[pageIdentifier]) {
        console.warn(`Unknown pageIdentifier "${pageIdentifier}" in table filter state`);
        return state;
      }

      return {
        ...state,
        [pageIdentifier]: {
          ...state[pageIdentifier],
          [propName]: value
        }
      };
    }

    case types.RESET_TABLE_FILTER_STATE: {
      const { pageIdentifier, preserveCurrentPage = true } = action.payload;

      if (!pageIdentifier || !initialState[pageIdentifier]) {
        return state;
      }
      return {
        ...state,
        [pageIdentifier]: {
          ...initialState[pageIdentifier],
          currentPage: preserveCurrentPage ? (state[pageIdentifier]?.currentPage ?? initialState[pageIdentifier].currentPage) : initialState[pageIdentifier].currentPage,
        },
      };
    }

    case types.SET_PAGINATION_NAV_SOURCE:
      return { ...state, paginationNavSource: action.payload };

    case types.CLEAR_PAGINATION_NAV_SOURCE:
      return { ...state, paginationNavSource: null };

    default:
      return state;
  }
};

export default tableFilterReducer;
